<script lang="ts">
    import { toasts } from "svelte-toasts";
    import ClearanceDialog from "./ClearanceDialog.svelte";

    export let purchase: string | number;

    let currentAction: string;

    function handleClearance() {
        toasts.clearAll();
        currentAction = "clearanceConfirmation";
    }

    function handleRemove() {
        toasts.clearAll();
        currentAction = "deleteConfirmation";
    }
</script>

<section class="clearanceActions">
    <img on:click={handleClearance} class="icon" src="/assets/icons/check.png" alt="Rozlicz">
    <img on:click={handleRemove} class="icon" src="/assets/icons/delete.png" alt="Usuń zakup">
</section>

<ClearanceDialog bind:currentAction bind:purchase />

<style lang="scss">
    .clearanceActions {
        .icon {
            width: 16px;
            cursor: pointer;
        }
    }
</style>